import './SuperAgent.scss';
import Component from './SuperAgent.js';
export default Component;
